/* eslint-disable */
/* tslint:disable */
/*
 * ---------------------------------------------------------------
 * ## THIS FILE WAS GENERATED VIA SWAGGER-TYPESCRIPT-API        ##
 * ##                                                           ##
 * ## AUTHOR: acacode                                           ##
 * ## SOURCE: https://github.com/acacode/swagger-typescript-api ##
 * ---------------------------------------------------------------
 */

import {
  Common,
  CreateUserTypeDtoTx,
  DeleteUserTypeDtoTx,
  GetDetailUserTypeDtoRx,
  GetUserTypeDtoRx,
  UpdateUserTypeDtoTx,
  UserTypeControllerCheckUserTypeParams,
  UserTypeControllerGetUserTypesParams,
} from './data-contracts';
import { ContentType, HttpClient, RequestParams } from './http-client';

export class UserTypeApi<SecurityDataType = unknown> extends HttpClient<SecurityDataType> {
  /**
   * No description
   *
   * @tags UserType API
   * @name UserTypeControllerGetUserTypes
   * @summary 회원 구분 조회
   * @request GET:/api/user-type
   * @secure
   */
  userTypeControllerGetUserTypes = (query: UserTypeControllerGetUserTypesParams, params: RequestParams = {}) =>
    this.request<GetUserTypeDtoRx, any>({
      path: `/api/user-type`,
      method: 'GET',
      query: query,
      secure: true,
      format: 'json',
      ...params,
    });
  /**
   * No description
   *
   * @tags UserType API
   * @name UserTypeControllerCreateUserType
   * @summary 회원 구분 등록
   * @request POST:/api/user-type
   * @secure
   */
  userTypeControllerCreateUserType = (data: CreateUserTypeDtoTx, params: RequestParams = {}) =>
    this.request<Common, any>({
      path: `/api/user-type`,
      method: 'POST',
      body: data,
      secure: true,
      type: ContentType.Json,
      format: 'json',
      ...params,
    });
  /**
   * No description
   *
   * @tags UserType API
   * @name UserTypeControllerDeleteUserType
   * @summary 회원 구분 삭제
   * @request DELETE:/api/user-type
   * @secure
   */
  userTypeControllerDeleteUserType = (data: DeleteUserTypeDtoTx, params: RequestParams = {}) =>
    this.request<Common, any>({
      path: `/api/user-type`,
      method: 'DELETE',
      body: data,
      secure: true,
      type: ContentType.Json,
      format: 'json',
      ...params,
    });
  /**
   * No description
   *
   * @tags UserType API
   * @name UserTypeControllerCheckUserType
   * @summary 회원 구분 중복 조회
   * @request GET:/api/user-type/check
   * @secure
   */
  userTypeControllerCheckUserType = (query: UserTypeControllerCheckUserTypeParams, params: RequestParams = {}) =>
    this.request<Common, any>({
      path: `/api/user-type/check`,
      method: 'GET',
      query: query,
      secure: true,
      format: 'json',
      ...params,
    });
  /**
   * No description
   *
   * @tags UserType API
   * @name UserTypeControllerGetUserType
   * @summary 회원 구분 상세 조회
   * @request GET:/api/user-type/{id}
   * @secure
   */
  userTypeControllerGetUserType = (id: number, params: RequestParams = {}) =>
    this.request<GetDetailUserTypeDtoRx, any>({
      path: `/api/user-type/${id}`,
      method: 'GET',
      secure: true,
      format: 'json',
      ...params,
    });
  /**
   * No description
   *
   * @tags UserType API
   * @name UserTypeControllerUpdateUserType
   * @summary 회원 구분 수정
   * @request PUT:/api/user-type/{id}
   * @secure
   */
  userTypeControllerUpdateUserType = (id: number, data: UpdateUserTypeDtoTx, params: RequestParams = {}) =>
    this.request<Common, any>({
      path: `/api/user-type/${id}`,
      method: 'PUT',
      body: data,
      secure: true,
      type: ContentType.Json,
      format: 'json',
      ...params,
    });
}
